export const updateProductsCounter = (count) => {
    const counter = document.querySelector('#listing-info__total span');

    if (counter) {
        counter.innerText = count;
    }
};
